import useDefinedContext from "hooks/useDefinedContext";
import { createContext } from "react";
import type { MeasurementSet } from "types";

export interface ChartSetSelectContextType {
  value: MeasurementSet[];
  onChange(sets: MeasurementSet[]): void;
  options: MeasurementSet[];
}

const ChartSetSelectContext = createContext<ChartSetSelectContextType | undefined>(undefined);
ChartSetSelectContext.displayName = "ChartSetSelectContext";

export function useChartSetSelectContext() {
  return useDefinedContext(ChartSetSelectContext);
}

export default ChartSetSelectContext;
